import styled from "styled-components";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { borderRadius } from "../../../design-system/tokens/borders";
import { rawColors } from "../../../design-system/tokens/colors";

export const StatusRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing[3]};
  padding: ${spacing[3]};
  border: 1px solid ${rawColors.stroke[200]};
  border-radius: ${borderRadius.lg};
  background-color: ${rawColors.grey[50]};
`;

export const StatusText = styled.span`
  ${typographyMixin("body", 3)}
  color: ${rawColors.text.mediumEmphasis};
`;

export const ConnectedBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${spacing[1]};
  ${typographyMixin("caption", 3)}
  color: ${rawColors.accent.green500};
`;

export const ConnectButton = styled.button`
  ${typographyMixin("caption", 3)}
  display: inline-flex;
  align-items: center;
  gap: ${spacing[2]};
  padding: ${spacing[2]} ${spacing[3]};
  border: 1px solid ${rawColors.stroke[300]};
  border-radius: ${borderRadius.md};
  background-color: ${rawColors.structural.white};
  color: ${rawColors.text.highEmphasis};
  cursor: pointer;

  &:hover:not(:disabled) {
    background-color: ${rawColors.grey[50]};
  }

  &:disabled {
    color: ${rawColors.text.lowEmphasis};
    cursor: not-allowed;
  }
`;

export const ErrorText = styled.span`
  ${typographyMixin("caption", 3)}
  color: ${rawColors.accent.red500};
`;
